import AssetLoadingConfigType from '../../../../common/scripts/Config/AssetLoadingConfigType';

const i18nAssetPathConfig: AssetLoadingConfigType = {
    bundleName: 'i18n',
    path: {
        json: {
            gameName: 'gameName',
            errorMessage: 'errorMessage',
            text: 'text',
        },
        spriteFrame: {
            allSpriteFrames: {
                isDir: true,
                path: '',
            },
        },
    },
};

export default i18nAssetPathConfig;
